/**
 * src/data/glossaryImages.js — ảnh minh hoạ cho các thuật ngữ trong từ điển.
 *
 * Ảnh nằm trong public/ nên đường dẫn cố định theo slug; danh sách dưới đây chỉ
 * để biết thuật ngữ nào ĐÃ có ảnh, tránh chèn thẻ <img> trỏ vào file không tồn tại.
 * Tự sinh lại khi thêm ảnh mới: tên file = slug của thuật ngữ.
 */
export const CO_ANH_THUAT_NGU = new Set([
  'bang-co-phan', 'bi-tu-choi-goi-von', 'bien-loi-nhuan-gop', 'boi-so-doanh-thu', 'bootstrapping',
  'bottom-up-market-sizing', 'bridge-round', 'burn-multiple', 'burn-rate', 'cac-la-gi',
  'chia-co-phan-dong-sang-lap', 'chong-pha-loang', 'churn-rate', 'chuyen-giao-so-huu-tri-tue',
  'cliff-vesting', 'co-phan-chet', 'co-phan-pho-thong', 'co-phan-uu-dai', 'cohort-la-gi',
  'cong-ty-co-phan-goi-von', 'cot-moc-goi-von', 'dang-ky-nhan-hieu', 'data-room', 'deal-flow',
  'diem-hoa-von', 'dieu-le-cong-ty', 'dinh-gia-qua-cao', 'dinh-gia-startup', 'discount-safe',
  'dong-vong-goi-von', 'due-diligence', 'esop-la-gi', 'exit-la-gi', 'ghe-hoi-dong-quan-tri', 'goi-von-la-gi',
  'gross-burn-net-burn', 'investor-update', 'khau-vi-dau-tu', 'kinh-te-don-vi', 'liquidation-preference',
  'loai-hinh-doanh-nghiep-startup', 'ltv-la-gi', 'mfn-clause', 'mo-hinh-tai-chinh', 'mrr-arr',
  'nghi-dinh-13-2023', 'nghi-dinh-38-2018', 'nha-dau-tu-dan-dat', 'nha-dau-tu-thien-than',
  'option-pool-shuffle', 'payback-period', 'pha-loang-co-phan', 'pha-loang-toan-phan',
  'phuong-phap-scorecard', 'pitch-deck-la-gi', 'pre-money-post-money', 'quy-dau-tu-mao-hiem',
  'quy-mo-thi-truong', 'quyen-mua-them', 'quyen-phu-quyet', 'runway-la-gi', 'safe-la-gi', 'safe-post-money',
  'safe-pre-money', 'series-a', 'so-tien-goi-von', 'su-dung-von', 'term-sheet', 'thoa-thuan-dong-sang-lap',
  'thu-cam-ket-mua', 'trai-phieu-chuyen-doi', 'trien-khai-thu', 'ty-le-ltv-cac', 'valuation-cap',
  'vesting-la-gi', 'vong-giam-gia', 'vong-pre-seed', 'vong-seed', 'vuon-uom-khoi-nghiep', 'warm-intro',
  // Bổ sung 19/10/2026 (design/thuat-ngu/gloss-specs.js)
  'phan-ky-dinh-gia', 'chiet-khau-kho-chuyen-nhuong', 'chung-quyen-warrant', 'co-tuc-tich-luy',
  'thac-phan-phoi-thanh-ly', 'pari-passu', 'quyen-thong-tin', 'quyen-yeu-cau-mua-lai', 'dieu-khoan-no-shop',
  'cam-doan-bao-dam', 'vong-tang-gia', 'co-phan-doi-cong-suc', 'dong-dau-tu', 'magic-number-saas', 'arpu-acv',
]);

/** Ảnh hiển thị trong bài (1600×900, WebP). */
export const anhThuatNgu = (slug) => (CO_ANH_THUAT_NGU.has(slug) ? `/anh/thuat-ngu/${slug}.webp` : '');
/** Ảnh chia sẻ Facebook/Zalo (1200×630, JPEG). */
export const anhChiaSeThuatNgu = (slug) => (CO_ANH_THUAT_NGU.has(slug) ? `/og/thuat-ngu/${slug}.jpg` : '');
